"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
function NewsGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-[400px] rounded-none bg-muted/20 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>Impossibile caricare i dossier in questo momento.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>Nessun aggiornamento disponibile nell'archivio.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <Link key={post.id} to={post.link || "#"} data-index={i} className="group block h-full focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary rounded-none">
          <Card className="h-full overflow-hidden border-white/10 shadow-none hover:border-secondary/50 transition-all duration-500 bg-white/5 backdrop-blur-md rounded-none">
            <div className="relative aspect-[4/3] overflow-hidden bg-muted">
              <img src={post.featuredImage || `/img/runet_intelligence_${i % 3 + 1}.png`} alt={post.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 grayscale group-hover:grayscale-0" />
              {}
              {post.categories && post.categories.length > 0 && <div className="absolute top-4 left-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <Badge variant="secondary" className="shadow-lg bg-secondary text-secondary-foreground font-mono text-[10px] uppercase tracking-widest rounded-none">
                    {post.categories[0].name}
                  </Badge>
                </div>}
            </div>
            <CardContent className="p-6 flex flex-col gap-3">
              <div className="text-[10px] text-secondary font-mono uppercase tracking-widest">
                {post.date ? new Date(post.date).toLocaleDateString('it-IT', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            }) : 'LIVE REPORT'}
              </div>
              <h3 className="font-default font-bold text-xl leading-tight text-foreground line-clamp-2 group-hover:text-primary transition-colors">
                {post.title}
              </h3>
              {post.excerpt && <p className="text-muted-foreground text-sm line-clamp-3 mt-auto font-default">
                  {post.excerpt.replace(/<[^>]*>?/gm, '')}
                </p>}
              <div className="mt-4 flex items-center text-primary font-mono text-xs uppercase tracking-tighter group-hover:translate-x-1 transition-transform duration-300">
                Leggi Dossier <ArrowRight className="ml-2 size-3" />
              </div>
            </CardContent>
          </Card>
        </Link>)}
    </div>;
}
export default function VidaEnComunidad() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="234047" id="osservatorio-strategico-runet" className="bg-background text-foreground py-20 md:py-32 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <h2 className="font-default font-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-4 tracking-tighter uppercase">
            Osservatorio Strategico RuNet
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Analisi settimanali, aggiornamenti algoritmici e intelligence tecnica sul mercato digitale russo.
          </p>
        </div>

        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <NewsGridConsumer />
        </PostsProvider>

        <div className="mt-12 md:mt-16 flex justify-center">
          <Link to="/HomePage">
            <Button variant="outline" size="lg" className="rounded-none px-8 font-mono uppercase tracking-widest border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300">
              Archivio Completo
              <ArrowRight className="ml-2 size-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}